module.exports = __webpack_public_path__ + "static/media/icon-notification-header.b0da2029.svg";